// Form Input
function FormInput(props) {
  const { content, displayName, children } = props || {};

  // action="javascript:void(-1)" :: to remove the reloading of page
  // on pressing "Enter button" for "FormInput"
  return (
    <form className="form-inline" action="javascript:void(-1)">
      <div className="form-group">
        <label id={content}>{displayName}</label>
        {children}
      </div>
    </form>
  );
}

// Input
function Input(props) {
  const {
    type = "",
    id,
    value = "",
    onChange = () => {},
    placeHolder = "",
    disabled = false,
    inputBoxStyle = "",
  } = props || {};

  // functions
  function handleChange(event) {
    const { value } = event.target || {};

    // callback
    onChange(id, value);
  }

  const inputType = type ? type : "text";
  const className = inputBoxStyle ? inputBoxStyle : "form-control";

  return (
    <input
      type={inputType}
      className={className}
      placeholder={placeHolder}
      value={value}
      onChange={handleChange}
      disabled={disabled}
    />
  );
}

export { Input, FormInput };
